/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/12/1
 * @updateTime 2021/12/1
 * @decription 保全预览 =》 变更担保审核信息入口js
 */
// 预览模块
import ccPreviewModule from '@/components/common/preview-module/index.vue';
// 数据转换
import transformData from '@/views/mixins/transform-data.js';
// 代码值
import {typeXxbqShjg} from "@/filters";
export default {
    name: 'app-preservation-preview-xxbq',
    // 混入
    mixins: [transformData],
    // 依赖组件
    components: {
        ccPreviewModule
    },
    // 参数
    props: {
        // 展现数据
        data: Object
    },
    // 数据
    data() {
        return {
            // 展现数据
            displayData: []
        };
    },
    // 计算属性
    computed: {},
    // 监听
    watch: {},
    // 创建完成
    async created() {
        // 创建完成
        // 进行数据转化
        this.displayData = this.getTransformData(this.data);
    },
    // 方法
    methods: {

        /**
         * 获取转换数据
         * @param {Object} data 源数据
         * @returns {Array<Object>}
         * */
        getTransformData(data) {
            // 审核状态为2，则说明正在审核中
            if (data.shzt === '2') {
                return [];
            }
            const _transformItemData = [];
            _transformItemData.push(this.getRowData('审核结果', typeXxbqShjg(data.shjg)));
            // 审核不通过，需要显示原因
            data.shjg === '2' && _transformItemData.push(this.getRowData('原因', data.shbtgyy));
            _transformItemData.push(this.getRowData('审核日期', data.shrq));
            return [_transformItemData];
        }
    }
};
